import { ContextManager } from "~/modules/contextManager/ContextManager";
import type { ClientOptions, Client } from "~/modules/client";
import type { DeepPartial } from "~/utils/DeepPartial";
import { assertNotEmptyString } from "~/utils/assert";
import { createClient } from "./createClient";

export const createClientWrapper = async (token: string, userOptions?: DeepPartial<ClientOptions>): Promise<Client> => {
    assertNotEmptyString(token, "token");

    return createClient(ContextManager.newInstance())(token, userOptions);
};
